import { render, staticRenderFns } from "./acc-watching.vue?vue&type=template&id=5f975d8d&scoped=true&"
import script from "./acc-watching.vue?vue&type=script&lang=js&"
export * from "./acc-watching.vue?vue&type=script&lang=js&"
import style0 from "./acc-watching.vue?vue&type=style&index=0&id=5f975d8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f975d8d",
  null
  
)

export default component.exports